{
  "title": "Rôles de l'équipe {{team}}",
  "titleUnnamed": "Rôles",
  "caption": "Les rôles regroupent les membres de cette équipe, comme « Caméraman » ou « Accueil ». Un bénévole peut en avoir plusieurs.",
  "newRolePlaceholder": "Nom du nouveau rôle",
  "addRole": "Ajouter un rôle",
  "adding": "Ajout...",
  "duplicateName": "Cette équipe a déjà un rôle portant ce nom.",
  "duplicateNamed": "Cette équipe a déjà un rôle nommé « {{name}} ».",
  "createFailed": "Impossible de créer ce rôle pour le moment.",
  "empty": "Aucun rôle pour l'instant. Ajoutez-en un ci-dessus pour commencer à organiser cette équipe.",
  "volunteers_one": "{{count}} bénévole",
  "volunteers_other": "{{count}} bénévoles",
  "trainingTitle": "Formation pour {{role}}",
  "trainingEmpty": "Aucune formation pour l'instant. Rien n'est assigné aux personnes qui reçoivent ce rôle.",
  "dueInBefore": "À faire dans",
  "dueInAfter": "jours",
  "dueInLabel": "Jours pour terminer {{module}}",
  "stopAssigning": "Ne plus assigner {{module}}",
  "invalidWindow": "Chaque délai doit être un nombre entier de jours, de {{min}} à {{max}}.",
  "addModule": "Ajouter un module de formation",
  "addModuleOption": "Ajouter un module de formation…",
  "noModules": "Cette église n'a encore aucun module de formation.",
  "trainingCaptionHolders_one": "Modifier les formations assignées à un rôle assignera automatiquement le module ajouté au bénévole qui a ce rôle actuellement.",
  "trainingCaptionHolders_other": "Modifier les formations assignées à un rôle assignera automatiquement le module ajouté aux {{count}} bénévoles qui ont ce rôle actuellement.",
  "trainingCaptionNoHolders": "Modifier les formations assignées à un rôle assignera automatiquement le module ajouté à toute personne qui recevra ce rôle plus tard.",
  "renameLabel": "Renommer {{role}}",
  "deleteLabel": "Supprimer {{role}}",
  "deleteConfirm": "Supprimer {{role}} ?",
  "deleteHolders_one": "Il sera retiré à {{count}} bénévole.",
  "deleteHolders_other": "Il sera retiré à {{count}} bénévoles.",
  "deleteNoHolders": "Personne n'a ce rôle.",
  "delete": "Supprimer",
  "deleting": "Suppression...",
  "summaryCount_one": "Assigne {{count}} module de formation",
  "summaryCount_other": "Assigne {{count}} modules de formation",
  "summaryList": "Assigne {{list}}",
  "summaryItem_one": "{{module}} ({{count}} jour)",
  "summaryItem_other": "{{module}} ({{count}} jours)",
  "listSeparator": ", ",
  "unknownModule": "Module inconnu",
  "assignedPart_one": "{{module}} à {{count}} bénévole",
  "assignedPart_other": "{{module}} à {{count}} bénévoles",
  "assignedNotice": "Assigné : {{parts}}.",
  "assignedJoiner": " et "
}
